@if (loaderService.isLoadingSignal()) {
  <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-white/60 backdrop-blur-sm">
    <div class="h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600"></div>
  </div>
}
<router-outlet></router-outlet>
